import * as Sentry from "@sentry/nextjs";
import React from "react";

const DefaultFallBack = ({ onRetry }) => (
  <div className="flex items-center justify-center w-full py-12 text-center">
    <div>
      <p className="text-sm font-medium text-neutral-400">
        Something went wrong loading this section.
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
        >
          Try again
        </button>
      )}
    </div>
  </div>
);

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error({ error, errorInfo });
    Sentry.captureException(error, {
      tags: {
        user_visible: true,
        component: "ErrorBoundary",
      },
      contexts: {
        react: { componentStack: errorInfo?.componentStack },
      },
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }
      return <DefaultFallBack onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}
